import { z } from 'zod';
import {
  IdSchema,
  ImageRefSchema,
  IsoDateSchema,
  SlugSchema,
} from './primitives.js';

export const UserRoleSchema = z.enum(['user', 'editor', 'admin']);

export const UserSchema = z.object({
  id: IdSchema,
  email: z.string().email(),
  handle: SlugSchema,
  displayName: z.string(),
  avatar: ImageRefSchema.optional(),
  bio: z.string().max(280).optional(),
  role: UserRoleSchema.default('user'),
  createdAt: IsoDateSchema,
  updatedAt: IsoDateSchema,
});

export type UserRole = z.infer<typeof UserRoleSchema>;
export type User = z.infer<typeof UserSchema>;
